export const apiUrl = "https://dev.konnectfbr.com/api";
//export const apiUrl = "http://localhost:3060";

